import React from 'react';
import { useIntl } from 'gatsby-plugin-intl';

import Elle from '../../images/Elle.png';
import Fortune from '../../images/Fortune.png';
import Vogue from '../../images/Vogue.png';
import Travel_Leisure from '../../images/Travel_Leisure.png';
import MensHealth from '../../images/MensHealth.png';
import CBS from '../../images/CBS.png';

export const References = () => {
  const intl = useIntl();

  return (
    <section className="relative w-full xl:container mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-16 z-10">
      <h2 className="text-2xl text-black font-heading font-normal mb-4">{intl.formatMessage({ id: 'references' })}</h2>
      <div className="flex items-center justify-between flex-wrap">
        <div className="w-1/3 lg:w-1/6 pb-6 lg:pb-0">
          <img src={Elle} className="w-20 md:w-24 h-auto" />
        </div>
        <div className="w-1/3 lg:w-1/6 pb-6 lg:pb-0 flex justify-center">
          <img src={Fortune} className="w-20 md:w-24 h-auto" />
        </div>
        <div className="w-1/3 lg:w-1/6 pb-6 lg:pb-0 flex justify-end lg:justify-center">
          <img src={Vogue} className="w-20 md:w-24 h-auto" />
        </div>
        <div className="w-1/3 lg:w-1/6 flex justify-star lg:justify-center">
          <img src={MensHealth} className="w-20 md:w-24 h-auto" />
        </div>
        <div className="w-1/3 lg:w-1/6 flex justify-center">
          <img src={CBS} className="w-24 md:w-32 h-auto" />
        </div>
        <div className="w-1/3 lg:w-1/6 flex justify-end lg:justify-center">
          <img src={Travel_Leisure} className="w-20 md:w-24 h-auto" />
        </div>
      </div>
    </section>
  );
};
